export enum DocumentsTypes {
  INE_FRONT = 'INE_FRONT',
  INE_BACK = 'INE_BACK',
  ACCEPTANCE_VIDEO = 'ACCEPTANCE_VIDEO',
  LEGAL_PDF = 'LEGAL_PDF',
}
